export enum LoggingLevel {
  Debug,
  Info,
  Warn,
  Error,
}
